/**
 * Label Utilities
 *
 * Shared utilities for converting enum/type values to display labels.
 */

/**
 * Get a display label for a value from a label map.
 * Returns the raw value if no mapping exists.
 */
export function getLabel<T extends string | number | symbol>(
  value: T,
  labelMap: Record<T, string>
): string {
  return labelMap[value] ?? String(value);
}

/**
 * Create a label getter function for a specific label map.
 * Useful for creating specialized label functions.
 */
export function createLabelGetter<T extends string | number | symbol>(
  labelMap: Record<T, string>
): (value: T) => string {
  return (value: T) => getLabel(value, labelMap);
}
